import { createAction } from '@reduxjs/toolkit';
import type { BoundaryTerritoryGroupId } from '../boundaries/boundaryIdentifier.type';
import { type BoundaryTerritoryGroup } from '../boundaryTerritoryGroups/boundaryTerritoryGroups.state';
import { type BoundaryTerritoryGroupDetails } from './boundaryTerritoryDetails.types';

export const boundaryTerritoryGroupsFetchDetailsRequest = createAction(
  'BOUNDARY_TERRITORY_DETAILS_FETCH_DETAILS_REQUEST',
  (boundaryTerritoryGroups: ReadonlyArray<BoundaryTerritoryGroup>) => ({
    payload: { boundaryTerritoryGroups },
  }),
);

// We are triggering the watcher that fetches details for all boundary groups that use bounding box. Hence the empty array.
export const boundaryTerritoryGroupsFetchBBOXDetailsRequest = () => boundaryTerritoryGroupsFetchDetailsRequest([]);

export const boundaryTerritoryGroupsFetchDetailsLoading = createAction(
  'BOUNDARY_TERRITORY_DETAILS_FETCH_DETAILS_LOADING',
  (btgIds: ReadonlyArray<BoundaryTerritoryGroupId>, queryIds: Readonly<Record<BoundaryTerritoryGroupId, string>>) => ({
    payload: { btgIds, queryIds },
  }),
);

export const boundaryTerritoryGroupsFetchDetailsSuccess = createAction(
  'BOUNDARY_TERRITORY_DETAILS_FETCH_DETAILS_SUCCESS',
  (
    results: ReadonlyArray<{
      boundaryTerritoryGroupId: BoundaryTerritoryGroupId;
      details: BoundaryTerritoryGroupDetails;
      queryId: string;
    }>,
  ) => ({
    payload: { results },
  }),
);

export const boundaryTerritoryGroupsFetchDetailsError = createAction(
  'BOUNDARY_TERRITORY_DETAILS_FETCH_DETAILS_ERROR',
  (error: Error, btgIds: ReadonlyArray<BoundaryTerritoryGroupId>) => ({
    payload: { error, btgIds },
  }),
);

export const boundaryTerritoryDetailsUpdateManualAssignments = createAction(
  'BOUNDARY_TERRITORY_DETAILS_UPDATE_MANUAL_ASSIGNMENTS',
  (boundaryTerritoryGroupId: number, manualAssignments: Readonly<{ [boundaryTerritoryId: string]: readonly number[] }>) => ({
    payload: { boundaryTerritoryGroupId, manualAssignments },
  }),
);

export const boundaryTerritoryDetailsZoomedLoadingStart = createAction('BOUNDARY_TERRITORY_DETAILS_ZOOMED_LOADING_START');

export const boundaryTerritoryDetailsInvalidate = createAction('BOUNDARY_TERRITORY_DETAILS_INVALIDATE');

export const boundaryTerritoryDetailsZoomedLoadingSuccess = createAction('BOUNDARY_TERRITORY_DETAILS_ZOOMED_LOADING_SUCCESS', (
  results: ReadonlyArray<{
    boundaryTerritoryGroupId: BoundaryTerritoryGroupId;
    details: BoundaryTerritoryGroupDetails;
  }>,
) => {
  return { payload: { results } };
});

export const boundaryTerritoryDetailsZoomedLoadingError = createAction('BOUNDARY_TERRITORY_DETAILS_ZOOMED_LOADING_ERROR', (error: Error) => {
  return { payload: { error } };
});
